var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCardsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.027451 0 0 0 0 0.117647 0 0 0 0 0.203922 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26 -16)",
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.445 24.393c1.663 0 3.018 1.297 3.018 2.889v12.496c0 1.591-1.355 2.889-3.018 2.889H29.018c-1.663 0-3.018-1.298-3.018-2.89V27.283c0-1.592 1.355-2.889 3.018-2.889zm.661 6.26h-22.75v9.131c0 .35.295.633.662.633h21.427c.367 0 .661-.288.661-.633v-9.13zm-17.178 5.76c.648 0 1.178.507 1.178 1.128 0 .62-.53 1.128-1.178 1.128h-2.527c-.648 0-1.178-.508-1.178-1.128 0-.62.53-1.129 1.178-1.129zm7.214-3.73c.655 0 1.179.508 1.179 1.129 0 .62-.53 1.128-1.179 1.128h-1.61c-.648 0-1.178-.508-1.178-1.128 0-.62.53-1.128 1.178-1.128zm-5.394 0c.648 0 1.178.508 1.178 1.129 0 .62-.53 1.128-1.178 1.128h-4.386c-.648 0-1.179-.508-1.179-1.128 0-.62.53-1.128 1.179-1.128zm14.697-6.034H29.018a.646.646 0 0 0-.661.633v1.115h22.75v-1.115a.646.646 0 0 0-.662-.633zM54.982 20C56.645 20 58 21.297 58 22.889v3.522c0 .62-.53 1.128-1.178 1.128-.649 0-1.179-.508-1.179-1.128v-3.522a.646.646 0 0 0-.661-.633H33.555c-.648 0-1.179-.508-1.179-1.128 0-.62.53-1.128 1.179-1.128z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardsDark);
export default __webpack_public_path__ + "static/media/icon-cards-dark.fbbb09e9fea4b44797e610f366a920f5.svg";
export { ForwardRef as ReactComponent };